import { useCallback, useMemo } from 'react'
import { SUPPORTED_CHAINS } from '../data/supported-chains'
import { useSelector } from 'react-redux'
import { selectDesiredNetworkId } from '../modules/web3/selectors'
import { isMainnet } from '../constants'
import {
  useDynamicContext,
  useSwitchNetwork,
} from '@dynamic-labs/sdk-react-core'

const useNetworkId = () => {
  const { primaryWallet, network: chainId } = useDynamicContext()
  const switchNetwork = useSwitchNetwork()
  const desiredNetworkId = useSelector(selectDesiredNetworkId)
  const wrongNetwork = useMemo(
    () => chainId !== desiredNetworkId,
    [chainId, desiredNetworkId],
  )

  const changeNetwork = useCallback(
    async (id: number) => {
      const chainInfo = SUPPORTED_CHAINS[String(id)]
      if (!chainInfo) {
        console.error('Chain info not found for chainId:', id, {
          chainInfo,
          SUPPORTED_CHAINS,
          isMainnet,
        })
        return
      }

      await switchNetwork({ wallet: primaryWallet, network: id })
    },
    [switchNetwork, primaryWallet],
  )

  return { networkId: chainId, wrongNetwork, changeNetwork }
}

export default useNetworkId
